"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatahubLegacyRedirectService = void 0;
var datahubLegacyRedirectService_1 = require("./datahubLegacyRedirectService");
Object.defineProperty(exports, "DatahubLegacyRedirectService", { enumerable: true, get: function () { return __importDefault(datahubLegacyRedirectService_1).default; } });
